var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerSnap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7543C12 14.4089 18.1815 8.72417 22.394 4.90708C23.2957 4.08998 24.3783 3.82775 25.2464 4.68056V4.68056C25.7711 5.19612 26.0696 6.33505 25.5448 6.85061L19.5 12.7894L18 14.2631",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.2633L18.7652 13.5115C19.4277 12.8606 20.5066 12.9204 21.093 13.6406V13.6406C21.607 14.2719 21.5561 15.1906 20.9754 15.7611L20.5 16.2282",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.4246L21.2652 15.6729C21.9277 15.0219 23.0066 15.0818 23.593 15.802V15.802C24.107 16.4333 24.0561 17.352 23.4754 17.9225L23 18.3895",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 18.9791L23.0652 18.2273C23.7277 17.5764 24.8066 17.6362 25.393 18.3565V18.3565C25.907 18.9877 25.8561 19.9065 25.2754 20.477L24.8 20.944L17.0828 28.4285C17.0283 28.4814 16.9625 28.5211 16.8903 28.5448L15.5758 28.9752C15.5255 28.9917 15.473 29.0001 15.4202 29.0001H15.2978C14.7693 29.0001 14.244 28.9163 13.7417 28.7518L13 28.5088L12.0571 28.0457C12.0192 28.0271 11.9837 28.0037 11.9516 27.9761L8.07483 24.6434C8.02539 24.6009 7.98474 24.5491 7.95516 24.491L7.53249 23.6605C7.51091 23.6181 7.49549 23.5728 7.4867 23.5261L7.19995 22",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17L6.01656 12.649C6.00558 12.5502 5.97993 12.4536 5.94046 12.3624L4.72668 9.55685C4.41266 8.83103 5.02561 8.04513 5.80606 8.17293L6.746 8.32684C6.91262 8.35412 7.06962 8.42314 7.20236 8.52747L9.26642 10.1498C9.41885 10.2696 9.53316 10.4311 9.59545 10.6147L10.4236 13.0554C10.4738 13.2035 10.5581 13.3378 10.6697 13.4474L11.5 14.2632",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.98242L17 4.92979",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1V4.92982",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4.92981L9 1.49121",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.80005,
    cy: 19.5,
    r: 0.5,
    stroke: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerSnap);
export default __webpack_public_path__ + "static/media/fingerSnap.0a57037aecd43d25f6066c3bfd069007.svg";
export { ForwardRef as ReactComponent };